import { Component } from '@angular/core';

@Component({
  selector: 'lib-settings-icon',
  standalone: true,
  imports: [],
  templateUrl: './settings-icon.component.html',
  styleUrl: './settings-icon.component.css',
})
export class SettingsIconComponent {}
